import React, { Fragment, } from 'react';
import './style.scss';
import { useSelector } from 'react-redux';
import Helpers from '@Apis/helpers';
import PRZLottieT from '@Components/Common/UI/PRZLottieT';

const Restricted = ({ moduleName, isOrgActive, style }) => {

  const user = useSelector((state) => state.UserReducers.user);
  const fixedMenuBar = user?.side_menu_bar_type === 'FIXED';
  const factorysetupProtected = globalThis.location.pathname.includes('production/configurations');
  const schedulingProtected = globalThis.location.pathname.includes('production/schedules');
  const JobCardProtected = globalThis.location.pathname.includes('production/job-works');

  return (
    <Fragment>
      <div style={{
        top: (() => {
          if (factorysetupProtected) {
            return '145px';
          } else if (schedulingProtected || JobCardProtected) {
            return '90px';
          } else {
            return '120px';
          }
        })()
        , ...style,
      }} className={isOrgActive ? (fixedMenuBar ? 'restricted__wrapper' : 'restricted__wrapper-collapsed') : 'restricted-org__wrapper'}>
        <div className="restricted-overlay">
          <div className="restricted-content__wrapper">
            <div className="restricted-content">
              <div className="restricted-lock__wrapper">
                <div className="restricted-lock">
                  <PRZLottieT
                    file={'restrictedLock.json'}
                  />
                </div>
              </div>
              {isOrgActive ? (
                <Fragment>
                  <div className="restricted-text-head">Premium Feature</div>
                  <div className="restricted-text-body">
                    {moduleName}
                    {' '}
                    feature is not available in your current plan.
                  </div>
                </Fragment>
              ) : (
                <Fragment>
                  <div className="restricted-text-head">Premium Feature</div>
                  <div className="restricted-text-body">
                    Your organization is currently inactive.
                  </div>
                </Fragment>
              )}
              <div className="restricted-contact-button__wrapper">
                <div
                  className="restricted-contact-button"
                  onClick={() => { Helpers.openNewConversationForPremiumFeature(moduleName); }}
                >
                  Contact Us
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment >
  );
};

export default Restricted;
